import { render, staticRenderFns } from "./ChannelPurpose.html?vue&type=template&id=27063fb0&scoped=true&"
import script from "./ChannelPurpose.js?vue&type=script&lang=js&"
export * from "./ChannelPurpose.js?vue&type=script&lang=js&"
import style0 from "./ChannelPurpose.scss?vue&type=style&index=0&id=27063fb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27063fb0",
  null
  
)

export default component.exports